export default __webpack_public_path__ + "static/Alexis-0e8fffbc07269270107f1bb34e7006fe.webp";